import defaultApi from '@/utils/request';

export default {
  Get(params) {
    return defaultApi({
      url: 's7x_stdResTreatPlan/Get',
      method: 'get',
      params,
    });
  },
};
